import axios from 'axios';
import { errorHandling } from '../errorHandling';
import { apiUrl } from '../apiUrl';

export const getFaqs = (categorie, search=null) => {
  let url = `${apiUrl()}/faqs`;
  const params = new URLSearchParams();

  if (categorie) {
    params.append('categorie', categorie);
  }
  if (search!=null) {
    params.append('search', search);
  }
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  return axios.get(url)
    .then(response => response.data)
    .catch(error => errorHandling(error));
};

export default getFaqs;
